import React from 'react';

function QuotationRequestExternalParty({ redirectBack, initialQuotationRequest, handleSubmit }) {
    return (
        <>
            <p>Voor externe partij verwachten we geen offerteverzoek kansactie</p>
        </>
    );
}

export default QuotationRequestExternalParty;
